import {Dialog, Transition} from '@headlessui/react';
import React, {useState, Fragment, useRef, useEffect} from 'react';
import {ExclamationTriangleIcon} from '@heroicons/react/24/outline';
import {ShieldCheckIcon} from '@heroicons/react/24/outline';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../../Selects/SelectSpace';
import {getEstadosAprovacao, getTemplatesEmailOrcamento, getEmailOrcamento} from '../../api';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer} from 'react-toastify';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import ReactQuill from 'react-quill';
import SelectModal from '../../../Selects/SelectModal';

// import { Container } from './styles';

function EmailPropostaModal({proposta, cancelar, enviar}) {
    const cancelButtonRef = useRef(null);
    const {t} = useTranslation();
    const [aprovacao, setAprovacao] = useState(null);
    const [justificacao, setJustificacao] = useState('');

    const [templatesEmailsOrcamentos, setTemplatesEmailsOrcamentos] = useState([]);
    const [templateEmailOrcamento, setTemplateEmailOrcamento] = useState(null);
    const [assuntoEmail, setAssuntoEmail] = useState('');
    const [emails, setEmails] = useState('');
    const [error, setError] = useState('');
    const [corpoEmail, setCorpoEmail] = useState('');

    const validateEmail = email => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };
console.log(proposta, "propostassssss");
    useEffect(() => {
        if (templateEmailOrcamento) {
            debugger;

            var _corpo = templateEmailOrcamento.corpo;
            _corpo = _corpo.replace('|titulo|', proposta.contactos[0].cortesia.label);
            _corpo = _corpo.replace('|nome|', proposta.contactos[0].nome);
            _corpo = _corpo.replace('|apelido|', proposta.contactos[0].apelido);

            setAssuntoEmail(templateEmailOrcamento.assunto);
            setCorpoEmail(_corpo);
        }
    }, [templateEmailOrcamento]);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    var modules = {
        // table: true, // disable table module

        toolbar: [
            [{header: [1, 2, 3, false]}],
            ['bold', 'italic', 'underline', 'strike'],
            [{script: 'sub'}, {script: 'super'}],
            ['image', 'code-block'],
            [{align: []}],
            [{list: 'ordered'}, {list: 'bullet'}],
            [{indent: '-1'}, {indent: '+1'}], // outdent/indent
            [{color: []}, {background: []}], // dropdown with defaults from theme
            ['clean'],
            ['link'],
        ],
    };

    useEffect(() => {
        getTemplatesEmailOrcamento(lang).then(res => {
            setTemplatesEmailsOrcamentos(res.data.templatesEmailsOrcamentos);
        });
        const idProposta = proposta.id
        debugger
        getEmailOrcamento(lang, idProposta).then(res => {
            setEmails(res.data.emails);
        });
    }, []);

    const handleChange = e => {
        const value = e.target.value;
        setEmails(value);

        const emailList = value
            .split(';')
            .map(email => email.trim())
            .filter(email => email !== '');

        const allValid = emailList.every(email => validateEmail(email));

        if (allValid) {
            setError('');
        } else {
            setError('Um ou mais endereços de email são inválidos. Separe por ;');
        }
    };

    return (
        <Transition.Root show as={Fragment}>
            <Dialog as="div" className="relative z-50 " initialFocus={cancelButtonRef} onClose={() => cancelar()}>
                <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                            <Dialog.Panel className="relative transform overflow-hidden rounded-[8px] bg-white text-left shadow-xl transition-all sm:my-8  ">
                                <div className="flex items-center justify-between px-4 py-2 border-b rounded-t bg-gray-50 border-gray-100">
                                    <div className="flex flex-row">
                                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                                            <EmailRoundedIcon className="h-6 w-6 text-green-600" aria-hidden="true" />
                                        </div>
                                        <h3 className="text-xl ml-4 mt-2 font-semibold text-gray-600 ">{t('email')}</h3>
                                    </div>
                                    <button
                                        type="button"
                                        className="inline-flex justify-end rounded-[8px] text-gray-500 px-1 py-1 text-sm font-semibold  shadow-sm hover:bg-gray-200 sm:ml-3 sm:w-auto"
                                        onClick={() => cancelar()}>
                                        <CloseIcon />
                                    </button>
                                </div>
                                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                                    <div className="mt-3  sm:ml-4 sm:mr-4 sm:mt-0 sm:text-left">
                                        <form>
                                            <div className="mb-3 ">
                                                <div>
                                                    <label htmlFor="assunto" className="block mb-2 text-sm font-medium text-gray-900 ">
                                                        {t('emails')}
                                                    </label>
                                                    <input
                                                        id="emails"
                                                        //rows="1"
                                                        maxLength={250}
                                                        value={emails}
                                                        onChange={handleChange}
                                                        className={`block p-2.5 w-full text-sm text-gray-900 rounded-[8px] border border-gray-300 focus:ring-blue-500 focus:border-blue-500  ${'bg-white '} `}
                                                        placeholder={t('escrevaEmail')}
                                                    />
                                                    {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
                                                </div>
                                            </div>
                                            <div className="mb-6">
                                                <div>
                                                    <label htmlFor="aprovacao" className="block mb-2 text-sm font-medium text-gray-900  ">
                                                        {t('templateEmail')}
                                                    </label>
                                                    {/* <div className="flex w-96"> */}
                                                    <SelectModal
                                                        id={'aprovacao'}
                                                        options={templatesEmailsOrcamentos}
                                                        value={templateEmailOrcamento}
                                                        onChange={e => {
                                                            setTemplateEmailOrcamento(e);
                                                        }}
                                                        noOptionsMessage={t('semopcoes')}
                                                        placeholder={t('selecioneOpcao')}
                                                    />
                                                    {/* </div> */}
                                                </div>
                                            </div>

                                            <div className="mb-3 ">
                                                <div>
                                                    <label htmlFor="assunto" className="block mb-2 text-sm font-medium text-gray-900 ">
                                                        {t('templateAssunto')}
                                                    </label>
                                                    <input
                                                        id="assunto"
                                                        //rows="1"
                                                        maxLength={250}
                                                        value={assuntoEmail}
                                                        onChange={e => {
                                                            setAssuntoEmail(e.target.value);
                                                        }}
                                                        className={`block p-2.5 w-full text-sm text-gray-900 rounded-[8px] border border-gray-300 focus:ring-blue-500 focus:border-blue-500  ${'bg-white '} `}
                                                        placeholder={t('escrevaDescricao')}
                                                    />
                                                </div>
                                            </div>

                                            <div className="mb-3 ">
                                                <label htmlFor="corpo" className="block mb-2 text-sm font-medium text-gray-900 ">
                                                    {t('templateCorpo')}
                                                </label>
                                                <ReactQuill
                                                    className={` h-[50%] w-[100%] `}
                                                    modules={modules}
                                                    //theme="snow"
                                                    value={corpoEmail}
                                                    onChange={setCorpoEmail}
                                                />
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                    <button
                                        type="button"
                                        disabled={!corpoEmail || !assuntoEmail}
                                        className="inline-flex w-full justify-center rounded-[8px] bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                                        onClick={() => {
                                            if (!corpoEmail || !assuntoEmail) return;

                                            enviar(assuntoEmail, corpoEmail, emails);
                                        }}>
                                        {t('enviarEmail')}
                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 inline-flex w-full justify-center rounded-[8px] bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                        onClick={() => cancelar()}
                                        ref={cancelButtonRef}>
                                        {t('cancelar')}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}

export default EmailPropostaModal;
